import { STORAGE_KEY_PREFIX } from "../constants";

export default function SwrLocalStorageProvider() {
  const storageKey = `${STORAGE_KEY_PREFIX}.swr.cache`;
  const emptyCache = "[]";
  const storedCache = localStorage.getItem(storageKey) ?? emptyCache;
  let cacheMap: Map<string, object>;

  // Fixes old broken caches
  try {
    cacheMap = new Map<string, object>(
      JSON.parse(storedCache) as Iterable<readonly [string, object]>
    );
  } catch(error) {
    console.error(error);
    cacheMap = new Map<string, object>(
      JSON.parse(emptyCache) as Iterable<readonly [string, object]>
    );
  }

  window.addEventListener("beforeunload", () => {
    const storableCache = JSON.stringify(Array.from(cacheMap.entries()));
    localStorage.setItem(storageKey, storableCache);
  });

  return cacheMap;
}
